// @noflow
/* eslint-disable no-console */

class PlayerManager {
  constructor(delegate) {
    this._delegate = delegate;
    this._videoId =
      this._delegate._player.props?.stream?.video_id ||
      this._delegate._player.props?.stream?.content_identification?.echostar_id ||
      0;

    if (this.enabled) {
      this.initEvents();
    }
  }

  get _franchise() {
    if (this._delegate._player?.props?.franchise) {
      const { franchiseSlug } = this._delegate._player.props;
      return this._delegate._player.props.franchise[`${franchiseSlug}`];
    }
    if (this._delegate._player?.props?.franchises) {
      const { franchiseSlug } = this._delegate._player.props;
      return this._delegate._player.props.franchises[`${franchiseSlug}`];
    }
    return {};
  }

  get _playerProps() {
    return this._delegate._player.props;
  }

  get _airing() {
    return {
      airing: this._delegate._player.props.airings[0],
      qvt: this._delegate._player.props.qvtPayload,
      networkDetails: this._delegate._player.props.networkDetails,
    };
  }

  get events() {
    return {};
  }

  get sourceType() {
    return this._delegate.sourceType;
  }

  initEvents() {
    if (process.env.IS_BROWSER) {
      Object.keys(this.events).forEach(eventKey => {
        this._delegate.on(eventKey, (...args) => {
          try {
            this.events[eventKey](...args);
          } catch (e) {
            console.warn('PlayerManager Error', e);
          }
        });
      });
    } else {
      // For native players we do subscribe to events just by implementing delegates
      // So if player exist we automatically receive events
    }
  }

  get enabled() {
    throw new Error('Please implement PlayerManager.enabled for your playermanager');
  }

  get _videoMetadata() {
    return this._delegate._player.props.videoMetadata;
  }

  get player() {
    return this._delegate?._player;
  }

  get delegate() {
    return this._delegate;
  }
}

export default PlayerManager;
